import React from "react";
import { Box, Paper, Typography } from "@mui/material";

const StatCard = ({ icon, label, value, color }) => (
  <Paper className="glass-card" sx={{ p: 3.5 }}>
    <Box sx={{ display: "flex", alignItems: "center", gap: 3 }}>
      <Box sx={{ width: 52, height: 52, borderRadius: "16px", bgcolor: `${color}15`, display: "flex", alignItems: "center", justifyContent: "center", flexShrink: 0 }}>
        {icon}
      </Box>
      <Box sx={{ minWidth: 0 }}>
        <Typography variant="caption" color="#64748b" fontWeight={600} sx={{ letterSpacing: "0.3px" }}>{label}</Typography>
        <Typography fontWeight={800} fontSize={24} color="#1e293b">{value}</Typography>
      </Box>
    </Box>
  </Paper>
);

export default StatCard;
